import LandingPageSettings from './LandingPageSettings';
export default LandingPageSettings;